/* PILSNERISH OS — pz-hero: pour centerpiece (assets/pz-pour.js), headline reveal, draggable floaters
 * (spin pins + chrome objects, which also block the pour), NOW_POURING rotating compilation window.
 * Degrades: no WebGL -> static composition (sprites + CSS gold pour).
 * R15: pour, floaters and glass run under prefers-reduced-motion too (Android battery saver reports reduce and the
 * hero sat frozen on a full skull); only the headline reveal still follows PZ.reduced.
 */
(function () {
  'use strict';
  var w = window, d = document;
  if (w.__pzHero) return;
  w.__pzHero = true;
  var PZ = w.PZ;
  if (!PZ || !PZ.onSection) return;

  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  var PHONE = w.matchMedia ? w.matchMedia('(max-width: 749px)') : { matches: false };
  function idleCb(f, t) { return (w.requestIdleCallback || function (g) { return setTimeout(g, 200); })(f, { timeout: t || 2000 }); }
  // run once after the window load event (optionally also after `cap` ms, whichever comes first)
  function afterLoad(cb, cap) {
    if (d.readyState === 'complete') { cb(); return; }
    var done = false, f = function () { if (!done) { done = true; cb(); } };
    w.addEventListener('load', f, { once: true });
    if (cap) setTimeout(f, cap);
  }
  function loadImg(src, prio) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      if (prio) im.fetchPriority = prio;
      im.onload = function () { res(im); };
      im.onerror = rej;
      im.src = src;
    });
  }

  /* ------------------------------------------------------------------ floaters */
  function initFloaters(el, stage) {
    var pins = Array.prototype.slice.call(el.querySelectorAll('[data-pin]'));
    var state = [], raf = 0, running = false, dead = false, t0 = performance.now(), stopIO = null;
    var SW = 0, SH = 0, pour = null, fGap = 1000 / 60, lastTick = 0;
    /* ---- R7 glass pin (Root + Branch, toybox model): full of beer, tilts slowly clockwise from -15 deg, spills over
       the low rim into the pool once the tilt passes it (~7 s), empties, eases back + refills, loops (~20 s).
       The level stays horizontal in world space (volume-preserving clip of the interior polygon). */
    var G_START = -15, G_RATE = 5, G_SPILL = 20, G_END = 78;
    function parea(P) { var a = 0; for (var i = 0, n = P.length; i < n; i++) { var p = P[i], q = P[(i + 1) % n]; a += p[0] * q[1] - q[0] * p[1]; } return Math.abs(a / 2); }
    function pclip(P, ux, uy, lv) {
      var out = [], n = P.length;
      for (var i = 0; i < n; i++) {
        var a = P[i], b = P[(i + 1) % n], ha = a[0] * ux + a[1] * uy - lv, hb = b[0] * ux + b[1] * uy - lv;
        if (ha <= 0) out.push(a);
        if ((ha <= 0) !== (hb <= 0)) { var t = ha / (ha - hb); out.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); }
      }
      return out;
    }
    function gUp(deg) { var r = deg * Math.PI / 180; return [-Math.sin(r), -Math.cos(r)]; }
    function gLevel(G, v, u) {
      var lo = 1e9, hi = -1e9, P = G.P;
      for (var i = 0; i < P.length; i++) { var h = P[i][0] * u[0] + P[i][1] * u[1]; if (h < lo) lo = h; if (h > hi) hi = h; }
      if (v <= 0) return lo;
      if (v >= G.A) return hi;
      for (var j = 0; j < 20; j++) { var mid = (lo + hi) / 2; if (parea(pclip(P, u[0], u[1], mid)) < v) lo = mid; else hi = mid; }
      return (lo + hi) / 2;
    }
    function gRim(G, u) { var a = G.rimL[0] * u[0] + G.rimL[1] * u[1], b = G.rimR[0] * u[0] + G.rimR[1] * u[1]; return a < b ? { h: a, p: G.rimL, dir: -1 } : { h: b, p: G.rimR, dir: 1 }; }
    function gCap(G, deg) { var u = gUp(deg), r = gRim(G, u); return parea(pclip(G.P, u[0], u[1], r.h)); }
    function gPath(P) { if (P.length < 3) return ''; var d = 'M' + P[0][0].toFixed(1) + ' ' + P[0][1].toFixed(1); for (var i = 1; i < P.length; i++) d += 'L' + P[i][0].toFixed(1) + ' ' + P[i][1].toFixed(1); return d + 'Z'; }
    function gDraw(G, deg) {
      var u = gUp(deg);
      if (G.O) {
        // opaque chrome glass: the beer shows in the top opening, pooled on the world-low side, receding as it empties
        var f = Math.pow(Math.max(0, Math.min(1, G.v / G.vFull)), 0.6), lo = 1e9, hi = -1e9;
        for (var k = 0; k < G.O.length; k++) { var hh = G.O[k][0] * u[0] + G.O[k][1] * u[1]; if (hh < lo) lo = hh; if (hh > hi) hi = hh; }
        var thr = lo + f * (hi - lo), fw = 0.012 * G.W;
        if (f < 0.03) { G.beer.setAttribute('d', ''); G.foam.setAttribute('d', ''); return; }
        G.beer.setAttribute('d', gPath(pclip(G.O, u[0], u[1], thr - fw)));
        G.foam.setAttribute('d', gPath(pclip(pclip(G.O, u[0], u[1], thr), -u[0], -u[1], -(thr - fw))));
        return;
      }
      var lv = gLevel(G, G.v, u), foam = Math.min(G.v, G.A) > G.A * 0.004 ? 16 : 0;
      G.beer.setAttribute('d', G.v > G.A * 0.002 ? gPath(pclip(G.P, u[0], u[1], lv - foam)) : '');
      G.foam.setAttribute('d', foam ? gPath(pclip(pclip(G.P, u[0], u[1], lv), -u[0], -u[1], -(lv - foam))) : '');
    }
    function glassInit(s, i) {
      var url = s.el.getAttribute('data-glass');
      if (!url) return;
      fetch(url, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (!j || dead || !j.interior_polygon) return;
        var W = j.w || 565, H = j.h || 900, sc = function (q) { return [q[0] * W, q[1] * H]; }, P = j.interior_polygon.map(sc);
        // R8: an opaque (liquid-chrome) glass draws its beer ON TOP of the sprite, inside the top opening
        var O = j.opaque && j.opening_polygon ? j.opening_polygon.map(sc) : null;
        var ns = 'http://www.w3.org/2000/svg', sv = d.createElementNS(ns, 'svg'), id = 'pzg' + i;
        sv.setAttribute('viewBox', '0 0 ' + W + ' ' + H); sv.setAttribute('preserveAspectRatio', 'none'); sv.setAttribute('class', 'pz-hero__glassliq' + (O ? ' is-top' : '')); sv.setAttribute('aria-hidden', 'true');
        sv.innerHTML = (O
          ? '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#FBDB72"/><stop offset=".5" stop-color="#E9B332"/><stop offset="1" stop-color="#B98112"/></linearGradient></defs>'
          : '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#F6CF55"/><stop offset=".55" stop-color="#E2AE25"/><stop offset="1" stop-color="#B07A0E"/></linearGradient></defs>') +
          '<path fill="url(#' + id + ')"/><path fill="#FFF3D0"/>';
        var mk = s.el.getAttribute('data-glass-mask');
        if (mk && !O) { var mu = 'url("' + mk + '")'; sv.style.webkitMaskImage = mu; sv.style.maskImage = mu; }
        if (O) s.el.appendChild(sv); else s.el.insertBefore(sv, s.el.firstChild);
        var G = { W: W, H: H, P: P, O: O, A: parea(P), rimL: P[0], rimR: P[P.length - 1], beer: sv.childNodes[1], foam: sv.childNodes[2], th: G_START, phase: 'tilt', pt: 0, acc: 0, last: 0 };
        G.vFull = gCap(G, G_SPILL); G.v = G.vFull;
        s.glass = G; s.base = G_START;
        gDraw(G, G_START);
      }).catch(function () {});
    }
    function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    // advance the glass cycle; returns the display angle
    function glassStep(s, now) {
      var G = s.glass, dt = G.last ? Math.min(0.05, (now - G.last) / 1000) : 0;
      G.last = now;
      var live = !!pour;
      if (live) {
        if (G.phase === 'tilt') {
          G.th += G_RATE * dt;
          if (G.th >= G_END || (G.th > G_SPILL + 15 && G.v < G.A * 0.02)) { G.phase = 'reset'; G.pt = 0; G.th0 = G.th; G.v0 = G.v; }
        } else {
          G.pt += dt;
          G.th = G.th0 + (G_START - G.th0) * ease(Math.min(1, G.pt / 2.6));
          G.v = G.v0 + (G.vFull - G.v0) * ease(Math.min(1, Math.max(0, (G.pt - 0.5) / 1.9)));
          if (G.pt >= 2.9) { G.phase = 'tilt'; G.th = G_START; G.v = G.vFull; }
        }
      }
      var deg = G.th + s.vx * 0.35;
      if (live && G.phase === 'tilt') {
        var cap = gCap(G, deg);
        if (G.v > cap) {
          var out = Math.min(G.v - cap, G.A * 0.45 * dt);
          G.v -= out; G.acc += out / G.A * (PHONE.matches ? 260 : 600);
          if (G.acc >= 1) {
            // lowest rim point in stage px: the pin box centre + the rotated local offset
            var u = gUp(deg), rim = gRim(G, u), k = s.w / G.W, lx = rim.p[0] * k - s.w / 2, ly = rim.p[1] * k - s.h / 2;
            var rr = deg * Math.PI / 180, c = Math.cos(rr), sn = Math.sin(rr);
            var cx = s.bx + s.ox + s.fx + s.w / 2, cy = s.by + s.oy + s.fy + s.h / 2, S = Math.max(0.6, s.w / 110);
            var X = cx + lx * c - ly * sn, Y = cy + lx * sn + ly * c;
            while (G.acc >= 1) { G.acc -= 1; pour.drop(X + (Math.random() - 0.5) * 3 * S, Y + (Math.random() - 0.5) * 2 * S, rim.dir * (25 + Math.random() * 30) * S, (10 + Math.random() * 25) * S, 0.72); }
          }
        }
      }
      gDraw(G, deg);
      return deg;
    }
    function measure() {
      SW = stage.clientWidth; SH = stage.clientHeight;
      state.forEach(function (s) { s.bx = s.el.offsetLeft; s.by = s.el.offsetTop; s.w = s.el.offsetWidth; s.h = s.el.offsetHeight; });
    }
    pins.forEach(function (pin, i) {
      var s = {
        el: pin, ox: 0, oy: 0, vx: 0, vy: 0, fx: 0, fy: 0, drag: false, id: null, lx: 0, ly: 0, lt: 0,
        ph: i * 1.7 + Math.random(), sp: 0.16 + (i % 3) * 0.05, amp: 9 + (i % 2) * 7, rot: (i % 2 ? -1 : 1) * (4 + i * 1.2),
        chrome: pin.classList.contains('is-chrome'), base: parseFloat(pin.style.getPropertyValue('--r')) || 0
      };
      state.push(s);
      if (pin.hasAttribute('data-glass')) glassInit(s, i);
      function down(e) {
        if (e.button != null && e.button !== 0) return;
        s.drag = true; s.id = e.pointerId; s.lx = e.clientX; s.ly = e.clientY; s.lt = performance.now();
        s.vx = 0; s.vy = 0;
        try { pin.setPointerCapture(e.pointerId); } catch (err) {}
        pin.classList.add('is-drag');
        e.preventDefault();
        e.stopPropagation();
        if (!raf) raf = requestAnimationFrame(tick);
      }
      function move(e) {
        if (!s.drag || e.pointerId !== s.id) return;
        var now = performance.now(), dt = Math.max(1, now - s.lt);
        var dx = e.clientX - s.lx, dy = e.clientY - s.ly;
        s.ox += dx; s.oy += dy;
        s.vx = s.vx * 0.3 + (dx / dt * 16) * 0.7; s.vy = s.vy * 0.3 + (dy / dt * 16) * 0.7;
        s.lx = e.clientX; s.ly = e.clientY; s.lt = now;
      }
      function up(e) {
        if (!s.drag || e.pointerId !== s.id) return;
        s.drag = false;
        pin.classList.remove('is-drag');
        if (performance.now() - s.lt > 80) { s.vx = 0; s.vy = 0; }
      }
      function click(e) { e.stopPropagation(); }
      pin.addEventListener('pointerdown', down);
      pin.addEventListener('pointerdown', function () { if (ftm) { clearTimeout(ftm); ftm = 0; } if (!raf) raf = requestAnimationFrame(tick); });
      pin.addEventListener('pointermove', move);
      pin.addEventListener('pointerup', up);
      pin.addEventListener('pointercancel', up);
      pin.addEventListener('click', click);
      pin.addEventListener('dragstart', function (e) { e.preventDefault(); });
      s.off = function () {
        pin.removeEventListener('pointerdown', down);
        pin.removeEventListener('pointermove', move);
        pin.removeEventListener('pointerup', up);
        pin.removeEventListener('pointercancel', up);
        pin.removeEventListener('click', click);
      };
    });
    measure();

    function apply(s, now) {
      var t = (now - t0) / 1000;
      // phones: the pins sit close to the kicker and each other, so they drift less
      var amp = PHONE.matches ? (s.glass ? 2 : Math.min(s.amp, 6)) : s.amp;
      s.fx = Math.sin(t * s.sp * 2 + s.ph) * amp;
      s.fy = Math.cos(t * s.sp * 1.6 + s.ph * 1.3) * amp * 0.8;
      var r = s.glass ? glassStep(s, now) : s.base + Math.sin(t * s.sp + s.ph) * s.rot + s.vx * 0.35;
      s.el.style.transform = 'translate3d(' + (s.ox + s.fx).toFixed(1) + 'px,' + (s.oy + s.fy).toFixed(1) + 'px,0) rotate(' + r.toFixed(2) + 'deg)';
    }
    // idle pacing by timer (see pz-pour next()): no animation frame is requested between the capped ticks
    var ftm = 0;
    function later() {
      var wait = fGap - (performance.now() - lastTick) - 4;
      if (wait > 2) { if (!ftm) ftm = setTimeout(function () { ftm = 0; if (!dead && !raf) raf = requestAnimationFrame(tick); }, wait); }
      else raf = requestAnimationFrame(tick);
    }
    var ext = false, fromPour = false; // ext: the pour's (capped) frame drives the floaters, one frame for both
    function tick(now) {
      raf = 0;
      if (dead) return;
      // idle budget: 60 fps (30 breathing) unless something is being dragged or thrown
      var busy = state.some(function (s) { return s.drag || s.vx || s.vy; });
      if (!busy && ext && !fromPour) return;
      if (!busy && !ext && now - lastTick < fGap - 3) { later(); return; }
      lastTick = now;
      state.forEach(function (s) {
        if (!s.drag) {
          s.ox += s.vx; s.oy += s.vy;
          s.vx *= 0.94; s.vy *= 0.94;
          if (Math.abs(s.vx) < 0.01) s.vx = 0;
          if (Math.abs(s.vy) < 0.01) s.vy = 0;
          var minX = -s.bx - s.w * 0.25, maxX = SW - s.bx - s.w * 0.75, minY = -s.by - s.h * 0.2, maxY = SH - s.by - s.h * 0.8;
          if (s.ox < minX) { s.ox = minX; s.vx = Math.abs(s.vx) * 0.55; }
          if (s.ox > maxX) { s.ox = maxX; s.vx = -Math.abs(s.vx) * 0.55; }
          if (s.oy < minY) { s.oy = minY; s.vy = Math.abs(s.vy) * 0.55; }
          if (s.oy > maxY) { s.oy = maxY; s.vy = -Math.abs(s.vy) * 0.55; }
        }
        apply(s, now);
      });
      if (state.some(function (s) { return s.drag || s.vx || s.vy; })) raf = requestAnimationFrame(tick);
      else if (running && !ext) later();
    }
    // off screen the animated spin sprites go back to their stills (no decoding, no raster)
    function spinSprites(on) {
      pins.forEach(function (pin) {
        var im = pin.querySelector('img[data-spin]');
        if (!im || !pin.classList.contains('is-spinning')) return;
        var still = im.getAttribute('data-still'), anim = im.getAttribute('data-spin');
        if (!still) return;
        var want = on ? anim : still;
        if (im.getAttribute('src') !== want) im.src = want;
      });
    }
    function setRunning(on) {
      running = on;
      spinSprites(on);
      if (on && !raf) raf = requestAnimationFrame(tick);
    }
    w.addEventListener('resize', measure);
    stopIO = PZ.inView(el, setRunning, { media: false });
    // spin pins load as small stills; desktop swaps in the animated sprite after the page load event
    afterLoad(function () {
      idleCb(function () {
        if (dead || PHONE.matches) return;
        pins.forEach(function (pin) {
          var im = pin.querySelector('img[data-spin]');
          if (!im) return;
          var u = im.getAttribute('data-spin'), pre = new Image();
          pre.decoding = 'async';
          im.setAttribute('data-still', im.getAttribute('src'));
          pre.onload = function () { if (!dead) { pin.classList.add('is-spinning'); if (running) im.src = u; } };
          pre.src = u;
        });
      });
    });
    return {
      measure: measure,
      setPour: function (p) { pour = p; ext = !!p; if (ftm) { clearTimeout(ftm); ftm = 0; } },
      // called from the pour's frame (same frame, same cap) while the hero is on screen
      step: function (now) { if (!running || raf) return; fromPour = true; tick(now); fromPour = false; },
      setBreath: function (on) { fGap = 1000 / (on ? 30 : 60); },
      // circle colliders (stage px) for the pour
      colliders: function () {
        var out = [];
        for (var i = 0; i < state.length; i++) {
          var s = state[i];
          if (!s.w || s.el.offsetParent === null) continue;
          out.push({
            x: s.bx + s.ox + s.fx + s.w / 2, y: s.by + s.oy + s.fy + s.h / 2,
            r: s.w * (s.chrome ? 0.36 : 0.26), vx: (s.drag || s.vx ? s.vx * 60 : 0), vy: (s.drag || s.vy ? s.vy * 60 : 0)
          });
        }
        return out;
      },
      destroy: function () {
        dead = true;
        if (raf) cancelAnimationFrame(raf);
        clearTimeout(ftm);
        if (stopIO) stopIO();
        w.removeEventListener('resize', measure);
        state.forEach(function (s) { s.off(); });
      }
    };
  }

  /* ------------------------------------------------------------------ pour */
  // Anchors in normalised sprite coords. Placeholders: pzimg-lukr-faucet-ink + pzimg-chrome-skull.
  var ANCH_PH = { spout: [0.52, 0.985], mouth: [0.5, 0.785, 0.13], exit: [0.5, 0.97], fh: 0.55, gap: 0.06, sw: 0.07 };
  var TILT = 20 * Math.PI / 180; // legacy skull tipped back: counterclockwise, mouth up to the tap
  var K_FAUCET = 0.612;          // legacy: faucet height vs skull sprite height
  // open-cranium skull (R3): the sprite is pre-tilted and drawn unrotated
  var KF = 0.52;                 // faucet height vs the reference skull height
  var SPOUT_GAP = 0.0565;        // spout tip above the far rim of the opening, vs the reference skull height
  var SKULL_K = 0.85;            // R6: the skull is drawn at 85% of the reference size, the faucet keeps its size and
                                 // stays at the top, so the beer falls further from the spout into the cranium
  var CLEAR = 90, CLEAR_M = 12;  // min gap from the headline block to the skull silhouette (desktop / mobile)
  // outflow look per opening: pour = falls clean from the lip (else a film down the chrome), film speed cap,
  // splat radius, spawn jitter (x S px), sideways push (x S px/s)
  var FLOW = {
    mouth: { pour: true, fv: 1, rad: 0.8, jit: 0.8, vx: -10 },
    nose: { fv: 0.42, rad: 0.5, jit: 0.3, vx: -2 },
    eye_l: { pour: true, fv: 1, rad: 0.72, jit: 0.4, vx: -6 },
    eye_r: { pour: true, fv: 1, rad: 0.76, jit: 0.4, vx: -5 },
    cranium: { fv: 0.3, rad: 0.62, jit: 0.25, vx: 0 }
  };

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function readPt(o, W, H) {
    if (!o) return null;
    var x = o.x != null ? o.x : (o.cx != null ? o.cx : o[0]);
    var y = o.y != null ? o.y : (o.cy != null ? o.cy : o[1]);
    var rx = o.rx != null ? o.rx : (o.w != null ? o.w / 2 : o[2]);
    if (x == null || y == null) return null;
    if (x > 1.5 || y > 1.5) { x /= W; y /= H; if (rx != null) rx /= W; }
    return [x, y, rx != null ? rx : 0.12];
  }
  function normAnchors(j, sk, fa) {
    try {
      var fj = j.faucet || {}, sj = j.skull || {};
      var fW = fj.w || fj.width || fa.naturalWidth, fH = fj.h || fj.height || fa.naturalHeight;
      var sW = sj.w || sj.width || sk.naturalWidth, sH = sj.h || sj.height || sk.naturalHeight;
      var spout = readPt(fj.spout || fj.spout_tip || j.spout || j.spout_tip, fW, fH);
      var mouth = readPt(sj.mouth || sj.mouth_ellipse || j.mouth || j.mouth_ellipse, sW, sH);
      var exit = readPt(sj.exit || sj.exit_point || j.exit || j.exit_point, sW, sH);
      if (!spout || !mouth || !exit) return null;
      var pl = j.preview_layout || {};
      return {
        spout: spout, mouth: mouth, exit: exit,
        fh: pl.faucet_height_vs_skull_height || 0.55,
        gap: pl.spout_tip_gap_above_skull_top_vs_skull_height != null ? pl.spout_tip_gap_above_skull_top_vs_skull_height : 0.06,
        sw: pl.stream_width_vs_faucet_width || fj.spout_width || 0.07
      };
    } catch (e) { return null; }
  }
  // open-cranium anchors: faucet spout + stream width (the skull geometry comes from PZPour.analyzeOpen)
  function normOpen(j, fa) {
    try {
      var fj = j.faucet || {}, pl = j.preview_layout || {};
      var spout = readPt(fj.spout || fj.spout_tip, fj.w || fa.naturalWidth, fj.h || fa.naturalHeight);
      if (!spout || !j.skull || !j.skull.openings || !j.skull.entry) return null;
      return { spout: spout, sw: pl.stream_width_vs_faucet_width || fj.spout_width || 0.07, open: true, faAR: fj.w && fj.h ? fj.w / fj.h : 0 };
    } catch (e) { return null; }
  }
  // skull geometry without pz-pour (should not happen): upright sprite, mouth ellipse from the anchors
  function fallbackAnalysis(A, img) {
    var asp = img.naturalWidth / img.naturalHeight, mx = (A.mouth[0] - 0.5) * asp, my = A.mouth[1] - 0.5, rx = A.mouth[2] * asp;
    return {
      tilt: 0, asp: asp, back: null, front: null, box: [-asp / 2, -0.5, asp / 2, 0.5],
      corner: [mx - rx * 0.8, my + 0.02], holeBottom: my + rx * 0.5, lip: [mx, my + rx * 0.5], target: [mx, my - rx * 0.4], silTop: -0.45
    };
  }

  function initPour(el, stage, floaters) {
    var root = el.querySelector('[data-pour]');
    var canvas = el.querySelector('[data-gl]');
    var cp = el.querySelector('[data-cp]');
    if (!root || !cp) return function () {};
    var imgFa = root.querySelector('[data-pour-faucet]'), imgSk = root.querySelector('[data-pour-skull]');
    var s1 = root.querySelector('[data-pour-s1]'), s2 = root.querySelector('[data-pour-s2]'), pool = root.querySelector('[data-pour-pool]');
    var mf = root.querySelector('[data-pour-mf]');
    var A = ANCH_PH, AN = null, G = null, pour = null, dead = false, stopIO = null, ro = null, ptr = null, lastMove = 0;
    var flow = parseFloat(el.getAttribute('data-flow') || '1') || 1;

    function rel(node) {
      if (!node || !node.offsetParent) return null;
      var r = node.getBoundingClientRect(), sr = stage.getBoundingClientRect();
      return { l: r.left - sr.left, r: r.right - sr.left, t: r.top - sr.top, b: r.bottom - sr.top };
    }

    // Faucet centred at the top, tipped-back skull below with the mouth under the spout, room for the drip
    // and the pool at the bottom. Faucet and skull straddle the centre line of the centerpiece box.
    function geom() {
      if (!imgFa.naturalWidth || !AN) return null;
      var sr = stage.getBoundingClientRect(), cr = cp.getBoundingClientRect();
      var W = sr.width, H = sr.height;
      if (!W || !H) return null;
      var bx = cr.left - sr.left, by = cr.top - sr.top, bw = cr.width, bh = cr.height;
      var mobile = W < 750;
      var faAR = imgFa.naturalWidth / imgFa.naturalHeight;
      var boxW = AN.box[2] - AN.box[0];
      var poolCap = clamp(H * (mobile ? 0.06 : 0.075), 20, 110);
      var top = by + Math.max(10, bh * 0.03), gap = bh * 0.015, drip = bh * 0.05;
      var span = AN.box[3] - AN.silTop;
      var sh = (by + bh - top - gap - drip - poolCap) / (K_FAUCET * A.spout[1] + span);
      sh = Math.min(sh, bh * (mobile ? 0.46 : 0.52), bw / boxW, bw / (K_FAUCET * faAR));
      if (!(sh > 20)) return null;
      var fh = K_FAUCET * sh, fw = fh * faAR;
      var off = (AN.target[0] - (AN.box[0] + AN.box[2]) / 2) * sh;
      var spX = bx + bw / 2 + off / 2;
      var faT = top, spY = faT + A.spout[1] * fh;
      var cy = spY + gap - AN.silTop * sh;
      var extra = (H - poolCap - drip) - (cy + AN.box[3] * sh);
      if (extra > 0) { var dn = extra * (mobile ? 0.2 : 0.35); faT += dn; spY += dn; cy += dn; }
      var cx = spX - AN.target[0] * sh;
      // keep the tilted skull inside the stage (mobile column)
      var over = cx + AN.box[2] * sh - (W - 4);
      if (over > 0) { cx -= over; spX -= over; }
      var S = clamp(sh / 338, 0.45, 1.8);
      var skull = { cx: cx, cy: cy, w: AN.asp * sh, h: sh, c: Math.cos(AN.tilt), s: Math.sin(AN.tilt), rot: AN.tilt };
      var box = [cx + AN.box[0] * sh, cy + AN.box[1] * sh, cx + AN.box[2] * sh, cy + AN.box[3] * sh];
      var cX = cx + AN.corner[0] * sh, cY = cy + AN.corner[1] * sh;
      var lX = cx + AN.lip[0] * sh, lY = cy + AN.lip[1] * sh; // overflow: over the front of the lower lip + the low corner
      // pool under the drip, clear of the bottom-left readout and the NOW_POURING window
      var lo = mobile ? 6 : W * 0.2, hi = W - (mobile ? 6 : W * 0.2);
      [el.querySelector('.pz-hero__read--bl'), el.querySelector('[data-now]')].forEach(function (n) {
        var r = rel(n);
        if (!r || r.b < H - poolCap - 14 * S) return;
        if (r.r <= lX) lo = Math.max(lo, r.r + 20); else if (r.l >= lX) hi = Math.min(hi, r.l - 20);
      });
      var half = mobile ? W : W * 0.24;
      return {
        W: W, H: H, S: S, mobile: mobile, an: AN,
        faucet: [spX - A.spout[0] * fw, faT, fw, fh], skull: skull, skullBox: box,
        spout: { x: spX, y: spY, w: fw * A.sw * 0.42 },
        hole: {
          bottomY: cy + AN.holeBottom * sh, spillY: cY,
          spills: [{ x: lX, y: lY + 4 * S, vx: 6, w: 0.62 }, { x: cX - 2.5 * S, y: cY + 3 * S, vx: -16, w: 0.38 }]
        },
        target: { x: spX, y: cy + AN.target[1] * sh },
        pool: [Math.max(lo, lX - half), Math.min(hi, lX + half), lX], poolCap: poolCap,
        floorY: H, minX: mobile ? -20 : spX - W * 0.36, maxX: mobile ? W + 20 : spX + W * 0.36,
        rate: (mobile ? 170 : 300) * flow
      };
    }
    // text extent of the headline block (kicker + h1), stage px: union of the text-node rects
    function headBox() {
      var box = null, sr = stage.getBoundingClientRect();
      [el.querySelector('[data-hero-kicker]'), el.querySelector('[data-hero-h1]')].forEach(function (n) {
        if (!n || !n.offsetParent) return;
        var tw = d.createTreeWalker(n, NodeFilter.SHOW_TEXT, null), tn, rg = d.createRange();
        while ((tn = tw.nextNode())) {
          if (!tn.nodeValue.trim()) continue;
          rg.selectNodeContents(tn);
          var rs = rg.getClientRects();
          for (var i = 0; i < rs.length; i++) {
            var r = rs[i];
            if (!r.width) continue;
            var b = { l: r.left - sr.left, r: r.right - sr.left, t: r.top - sr.top, b: r.bottom - sr.top };
            box = box ? { l: Math.min(box.l, b.l), r: Math.max(box.r, b.r), t: Math.min(box.t, b.t), b: Math.max(box.b, b.b) } : b;
          }
        }
      });
      return box;
    }
    // leftmost silhouette u of the skull sprite within sprite rows v0..v1 (2 = no rows)
    function rowMinU(v0, v1) {
      var rm = AN.rowMin, n = rm.length, a = Math.max(0, Math.floor(v0 * n)), b = Math.min(n - 1, Math.ceil(v1 * n)), m = 2;
      for (var i = a; i <= b; i++) if (rm[i] < m) m = rm[i];
      return m;
    }
    // Open-cranium layout: faucet centred on the centerpiece box, spout just above the far rim of the broken
    // cranium, chin just above the pool cap. The skull faces the headline: keep its silhouette CLEAR px away
    // from the headline text (shift right up to 2.5% of the width, 5% below 1200px, then shrink).
    function geomOpen() {
      if (!AN || !(A.faAR || imgFa.naturalWidth)) return null;
      var sr = stage.getBoundingClientRect(), cr = cp.getBoundingClientRect();
      var W = sr.width, H = sr.height;
      if (!W || !H) return null;
      var bx = cr.left - sr.left, by = cr.top - sr.top, bw = cr.width, bh = cr.height;
      var mobile = W < 750, asp = AN.asp, sil = AN.sil, ent = AN.entry;
      var faAR = A.faAR || imgFa.naturalWidth / imgFa.naturalHeight;
      var poolCap = clamp(H * (mobile ? 0.06 : 0.075), 20, 110);
      var top0 = by + Math.max(10, bh * 0.03);
      var chinY = H - poolCap - Math.max(4, H * 0.008);
      var kv = KF * A.spout[1] + SPOUT_GAP - ent[1] + sil[3];
      var sh0 = (chinY - top0) / kv;                      // reference size: the R3/R4 stack filling the height
      sh0 = Math.min(sh0, bw * (mobile ? 1.02 : 1.25) / (asp * (sil[2] - sil[0])));
      if (!(sh0 > 40)) return null;
      var sh = sh0 * SKULL_K, fhRef = KF * sh0;           // faucet size from the reference, skull 15% smaller
      var cx0 = bx + bw / 2, spX = cx0;
      function lay(s, x) { return { sh: s, sx: x - ent[0] * asp * s, top: chinY - sil[3] * s }; }
      var L = lay(sh, spX), hb = headBox(), gapMin = mobile ? CLEAR_M : CLEAR, rLim = W - (mobile ? 6 : 16);
      // right edge: the skull never leaves the stage (the mirrored skull faces right, most of it sits right of the spout)
      function fitRight() {
        var over = L.sx + sil[2] * asp * L.sh - rLim;
        if (over > 0.5) { spX -= over; L = lay(L.sh, spX); }
      }
      fitRight();
      if (hb) {
        for (var it = 0; it < 6; it++) {
          var mu = rowMinU((hb.t - 16 - L.top) / L.sh, (hb.b + 16 - L.top) / L.sh);
          if (mu > 1) break;
          var need = hb.r + gapMin - (L.sx + mu * asp * L.sh);
          if (need <= 0.5) break;
          // room to move right without leaving the stage (and within the centring allowance)?
          var room = Math.max(0, rLim - (L.sx + sil[2] * asp * L.sh));
          var shift = Math.min(need, room, Math.max(0, W * (mobile ? 0.04 : (W < 1200 ? 0.05 : 0.025)) - (spX - cx0)));
          if (shift > 0) { spX += shift; need -= shift; L = lay(L.sh, spX); }
          if (need > 0.5) {
            // shrink to the span between the headline gap and the right limit, pinned to the headline side
            var span = rLim - (hb.r + gapMin), width = (sil[2] - mu) * asp * L.sh;
            sh = L.sh * Math.max(0.55, Math.min(0.98, span / width));
            spX = hb.r + gapMin + (ent[0] - mu) * asp * sh;
            L = lay(sh, spX);
          }
          fitRight();
        }
      }
      sh = L.sh;
      var sw = asp * sh, sx0 = L.sx, sy0 = L.top;
      // faucet at the top of the stack (its reference size); the skull sits on the floor, so the fall from the spout
      // to the far rim is the freed height (never less than the R4 gap)
      var fh = fhRef, fw = fh * faAR, faT = top0, spY = faT + A.spout[1] * fh;
      var rimY = sy0 + ent[1] * sh;
      if (rimY - spY < SPOUT_GAP * sh0) { spY = rimY - SPOUT_GAP * sh0; faT = spY - A.spout[1] * fh; }
      var S = clamp(sh / 338, 0.45, 1.8);
      function X(u) { return sx0 + u * sw; }
      function Y(v) { return sy0 + v * sh; }
      var ops = AN.openings.map(function (o) {
        var st = FLOW[o.key] || FLOW.eye_l;
        return {
          key: o.key, hLip: o.hLip, hFull: o.hFull, yA: Y(o.appear), yF: Y(o.full), kappa: o.kappa, exp: o.exp, cap: o.cap,
          spills: o.spills.map(function (p) { return { x: X(p[0]), y: Y(p[1]), w: p[2] }; }),
          fv: st.fv, rad: st.rad, jit: st.jit, vx: st.vx, pour: !!st.pour,
          bb: o.bbox ? [X(o.bbox[0]), Y(o.bbox[1]), X(o.bbox[2]), Y(o.bbox[3])] : null
        };
      });
      // R7: the pool spreads across the full width of the hero (behind the NOW_POURING window); the bottom-left
      // readout is lifted above it (--pz-pool)
      var pc = X((sil[0] + sil[2]) / 2), lo = 0, hi = W, half = W;
      return {
        W: W, H: H, S: S, mobile: mobile, an: AN, open: true,
        faucet: [spX - A.spout[0] * fw, faT, fw, fh],
        skull: { cx: sx0 + sw / 2, cy: sy0 + sh / 2, w: sw, h: sh, c: 1, s: 0, rot: 0 },
        skullBox: [X(sil[0]), Y(sil[1]), X(sil[2]), Y(sil[3])],
        spout: { x: spX, y: spY, w: fw * A.sw * 0.42 },
        vessel: { ops: ops, segs: AN.level.segs, hSteady: AN.level.hSteady },
        pool: [Math.max(lo, pc - half), Math.min(hi, pc + half), pc], poolCap: poolCap,
        floorY: H, minX: -20, maxX: W + 20,
        rate: (mobile ? 170 : 300) * flow,
        clear: hb ? { head: hb, gap: Math.round(sx0 + rowMinU((hb.t - 16 - sy0) / sh, (hb.b + 16 - sy0) / sh) * sw - hb.r), shift: Math.round(spX - cx0) } : null
      };
    }
    function place(node, x, y, wd, ht) {
      if (!node) return;
      node.style.left = x.toFixed(1) + 'px'; node.style.top = y.toFixed(1) + 'px';
      node.style.width = wd.toFixed(1) + 'px'; node.style.height = ht.toFixed(1) + 'px';
    }
    // static composition (no WebGL): the settled state, mouth full and pool at its cap
    function layoutStatic(g) {
      var k = g.skull, rot = 'rotate(' + (-k.rot).toFixed(4) + 'rad)';
      place(imgFa, g.faucet[0], g.faucet[1], g.faucet[2], g.faucet[3]);
      place(imgSk, k.cx - k.w / 2, k.cy - k.h / 2, k.w, k.h);
      imgSk.style.transform = rot;
      var sw = Math.max(6, g.spout.w * 2.4);
      place(s1, g.spout.x - sw / 2, g.spout.y - 2, sw, g.hole.spillY - g.spout.y + 6);
      if (mf) {
        var bx = g.skullBox;
        place(mf, bx[0], g.hole.spillY, bx[2] - bx[0], Math.max(0, g.hole.bottomY - g.hole.spillY + 2));
        var inner = mf.firstElementChild;
        if (inner) {
          place(inner, k.cx - k.w / 2 - bx[0], k.cy - k.h / 2 - g.hole.spillY, k.w, k.h);
          inner.style.transform = rot;
        }
      }
      var sp = g.hole.spills[0];
      place(s2, sp.x - sw * 0.35, sp.y - 4, sw * 0.7, g.floorY - g.poolCap * 0.8 - sp.y + 4);
      place(pool, g.pool[0], g.floorY - g.poolCap, g.pool[1] - g.pool[0], g.poolCap + 2);
      root.classList.add('is-laid');
    }
    // open cranium, static (no WebGL / before GL): unrotated skull, beer in every opening (fill mask),
    // the stream into the cranium, the mouth pour and the pool at its cap
    // move a first-paint sprite onto its computed box with a transform only (translate + scale about its CSS box):
    // transforms are not layout shifts, and the CSS box already approximates the layout
    function placeT(node, x, y, wd, ht) {
      if (!node) return;
      node.style.transform = 'none';
      var sr = stage.getBoundingClientRect(), r = node.getBoundingClientRect();
      if (!r.height) { place(node, x, y, wd, ht); return; }
      var sc = ht / r.height;
      node.style.transform = 'translate(' + (x - (r.left - sr.left)).toFixed(1) + 'px,' + (y - (r.top - sr.top)).toFixed(1) + 'px) scale(' + sc.toFixed(4) + ')';
    }
    function layoutStaticOpen(g) {
      var k = g.skull, x0 = k.cx - k.w / 2, y0 = k.cy - k.h / 2, cr = null, mo = null;
      g.vessel.ops.forEach(function (o) { if (o.key === 'cranium') cr = o; else if (o.key === 'mouth') mo = o; });
      placeT(imgFa, g.faucet[0], g.faucet[1], g.faucet[2], g.faucet[3]);
      placeT(imgSk, x0, y0, k.w, k.h);
      var sw = Math.max(6, g.spout.w * 2.4);
      place(s1, g.spout.x - sw / 2, g.spout.y - 2, sw, (cr ? cr.yF : y0 + k.h * 0.2) - g.spout.y + 12);
      if (mf) {
        place(mf, x0, y0, k.w, k.h);
        var inner = mf.firstElementChild;
        if (inner) { place(inner, 0, 0, k.w, k.h); inner.style.transform = 'none'; }
      }
      var sp = mo && mo.spills.length ? mo.spills[(mo.spills.length / 2) | 0] : { x: k.cx, y: y0 + k.h * 0.8 };
      place(s2, sp.x - sw * 0.4, sp.y - 4, sw * 0.8, g.floorY - g.poolCap * 0.8 - sp.y + 4);
      place(pool, g.pool[0], g.floorY - g.poolCap, g.pool[1] - g.pool[0], g.poolCap + 2);
      root.classList.add('is-laid');
    }
    // R10 phones: the chrome glass goes in the empty space under the headline, right of the NOW_POURING window, left of
    // the skull, above the coords. Largest size whose full rotation circle (the tilt reaches ~80 deg) fits the slot.
    function placePhoneGlass(g) {
      var pin = el.querySelector('.pz-hero__pin.is-glass');
      if (!pin) return;
      if (!g.mobile) { pin.classList.remove('is-slot'); pin.style.left = pin.style.top = pin.style.width = ''; return; }
      var hb = headBox(), nw = rel(el.querySelector('[data-now]')), cr = rel(el.querySelector('.pz-hero__read--bl'));
      if (!hb || !nw || !cr) { pin.classList.remove('is-slot'); return; }
      var k = g.skull, x0k = k.cx - k.w / 2, y0k = k.cy - k.h / 2, rm = AN.rowMin, n = rm.length;
      function skullLeft(ya, yb) {
        var a = Math.max(0, Math.floor((ya - y0k) / k.h * n)), b = Math.min(n - 1, Math.ceil((yb - y0k) / k.h * n)), m = 2;
        for (var i = a; i <= b; i++) if (rm[i] < m) m = rm[i];
        return m > 1 ? g.W - 6 : x0k + m * k.w;
      }
      var ar = 502 / 300, L = nw.r + 8, T = hb.b + 12, B = cr.t - 6, best = null;
      for (var gw = 72; gw >= 34 && !best; gw -= 2) {
        var R = Math.sqrt(1 + ar * ar) * gw / 2;
        for (var cy = B - R; cy >= T + R; cy -= 4) {
          var cx = L + R, right = skullLeft(cy - R, cy + R) - 6;
          if (cx + R <= right) { best = { gw: gw, cx: Math.min(cx + (right - cx - R) * 0.4, right - R), cy: cy }; break; }
        }
      }
      if (!best) { pin.classList.remove('is-slot'); return; }
      pin.classList.add('is-slot');
      pin.style.width = best.gw + 'px';
      pin.style.left = (best.cx - best.gw / 2).toFixed(1) + 'px';
      pin.style.top = (best.cy - best.gw * ar / 2).toFixed(1) + 'px';
    }
    function relayout() {
      var g = AN && AN.open ? geomOpen() : geom();
      if (!g) return;
      G = g;
      if (g.open) layoutStaticOpen(g); else layoutStatic(g);
      if (g.open) placePhoneGlass(g);
      if (pour) pour.layout(g);
      if (floaters) floaters.measure();
    }

    // colliders: cursor + floaters
    function local(e) {
      var r = stage.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function onMove(e) {
      if (!pour || !G) return;
      if (e.target.closest && e.target.closest('[data-pin], [data-now]')) { ptr = null; stage.classList.remove('is-aim'); return; }
      var p = local(e), now = performance.now();
      if (ptr) {
        var dt = Math.max(8, now - lastMove) / 1000;
        ptr.vx = ptr.vx * 0.4 + ((p.x - ptr.x) / dt) * 0.6;
        ptr.vy = ptr.vy * 0.4 + ((p.y - ptr.y) / dt) * 0.6;
        ptr.x = p.x; ptr.y = p.y;
      } else ptr = { x: p.x, y: p.y, vx: 0, vy: 0, r: 24 * G.S };
      ptr.r = 24 * G.S;
      lastMove = now;
      stage.classList.toggle('is-aim', !!pour.hit(p.x, p.y));
    }
    function onLeave() { ptr = null; stage.classList.remove('is-aim'); }
    function onClick(e) {
      if (!pour || !G) return;
      if (e.target.closest && e.target.closest('[data-pin], a, button')) return;
      var p = local(e);
      if (pour.shoot(p.x, p.y)) stage.classList.add('is-aim');
    }
    var colTimer = 0;
    // called by the pour before each (capped) frame: no separate always-on rAF loop
    function pushColliders() {
      if (dead || !pour) return;
      if (floaters && floaters.step) floaters.step(performance.now());
      var list = floaters ? floaters.colliders() : [];
      if (ptr) {
        if (performance.now() - lastMove > 90) { ptr.vx *= 0.8; ptr.vy *= 0.8; }
        list.push(ptr);
      }
      pour.setColliders(list);
    }
    // idle budget: 45 s without pointer / scroll / key input once the pour is in its steady state -> breathing
    // mode (30 fps); any input -> back to 60 fps
    var lastInput = performance.now(), breath = false, idleT = 0;
    function setBreath(on) {
      if (breath === on) return;
      breath = on;
      if (pour) pour.setFps(on ? 30 : 60);
      if (floaters && floaters.setBreath) floaters.setBreath(on);
    }
    function onInput() { lastInput = performance.now(); if (breath) setBreath(false); }
    var INPUTS = ['pointermove', 'pointerdown', 'wheel', 'scroll', 'touchstart', 'keydown'];

    // pick sprites: the hero-* files when their anchors JSON exists, else placeholders
    var custom = root.getAttribute('data-custom') === '1';
    var sprites = null; // [back|null, front, faucet]
    var jsonP = custom ? Promise.resolve(null) : fetch(root.getAttribute('data-anchors'), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    function placeholders() {
      var sp = root.getAttribute('data-skull-ph'), fp = root.getAttribute('data-faucet-ph');
      return Promise.all([loadImg(sp), loadImg(fp)])
        .then(function (ims) {
          A = ANCH_PH;
          imgSk.src = sp; imgFa.src = fp;
          AN = w.PZPour && w.PZPour.analyze ? w.PZPour.analyze(null, ims[0], 0, A) : null;
          if (!AN) AN = fallbackAnalysis(A, ims[0]);
          return [null, ims[0], ims[1]];
        });
    }
    function imgReady(im) {
      return im.complete && im.naturalWidth ? Promise.resolve() : new Promise(function (r) {
        im.addEventListener('load', r, { once: true }); im.addEventListener('error', r, { once: true });
      });
    }
    function goStatic() {
      root.classList.add('is-static');
      // no GL hand-off: swap the small first-paint sprites for the full ones (low priority)
      if (AN && AN.open) [[imgSk, 'data-skull'], [imgFa, 'data-faucet']].forEach(function (p) {
        var u = root.getAttribute(p[1]);
        if (u && p[0].getAttribute('src') !== u) loadImg(u, 'low').then(function () { if (!dead) p[0].src = u; }, function () {});
      });
    }
    // GL hand-off shared by both paths: create the pour, upload the sprites, then run
    function startGL() {
      if (dead) return;
      var opts = { canvas: canvas, max: stage.clientWidth < 750 ? 700 : 1300, dprMax: PHONE.matches ? 1 : 1.5, fps: 60, onFrame: pushColliders };
      // shaders compile off the main thread where the browser supports it; poll, then finish
      var pre = w.PZPour.prepare ? w.PZPour.prepare(opts) : null, tries = 0;
      if (w.PZPour.prepare && !pre) { goStatic(); return; }
      (function wait() {
        if (dead) return;
        if (pre && !pre.ready() && tries++ < 200) { setTimeout(wait, 25); return; }
        buildGL(pre ? pre.create() : w.PZPour.create(opts));
      })();
    }
    function buildGL(p0) {
      if (dead) return;
      if (!p0) { goStatic(); return; }
      // each step is its own task (shader compile, texture upload, layout, prewarm slices) so a slow phone never
      // sees one long freeze
      var up = function (slot, im) { return function () { if (dead) throw 0; if (p0.setSprite) p0.setSprite(slot, im); return yieldT(); }; };
      var chain = yieldT();
      if (p0.setSprite) chain = chain.then(up('back', sprites[0])).then(up('front', sprites[1])).then(up('faucet', sprites[2])).then(up('op', sprites[3] || null));
      else chain = chain.then(function () { p0.setSprites(sprites[0], sprites[1], sprites[2], sprites[3] || null); return yieldT(); });
      chain.then(function () { if (dead) throw 0; pour = p0; root.__pour = pour; relayout(); return yieldT(); })
        .then(function () {
          if (dead) throw 0;
          pour.prewarm(0.25); return yieldT();
        })
        .then(function () { if (dead) throw 0; pour.prewarm(0.25); return yieldT(); })
        .then(function () { if (dead) throw 0; pour.prewarm(0.25); return yieldT(); })
        .then(function () { if (dead) throw 0; pour.prewarm(0.25); runGL(); })
        .catch(function (e) { if (e) fail(e); });
    }
    function runGL() {
      root.classList.add('is-gl');
      if (floaters && floaters.setPour) floaters.setPour(pour);
      stage.addEventListener('pointermove', onMove, { passive: true });
      stage.addEventListener('pointerleave', onLeave);
      stage.addEventListener('click', onClick);
      stopIO = PZ.inView(el, function (on) { if (on && !d.hidden) pour.start(); else pour.stop(); }, { media: false });
      d.addEventListener('visibilitychange', onVis);
      INPUTS.forEach(function (ev) { w.addEventListener(ev, onInput, { passive: true, capture: true }); });
      idleT = setInterval(function () {
        if (!pour || !pour.running() || breath) return;
        if (performance.now() - lastInput > 45000 && pour.sim.time > 25) setBreath(true);
      }, 1000);
    }
    function fail(err) { console.warn('[pz-hero] pour disabled:', err && err.message); goStatic(); relayout(); }
    // yield to the main thread between init chunks (keeps each task short on slow phones)
    function yieldT(v) { return new Promise(function (r) { setTimeout(function () { r(v); }, 0); }); }
    function decoded(im) { return im && im.decode ? im.decode().then(function () { return im; }, function () { return im; }) : Promise.resolve(im); }
    // GL textures as premultiplied ImageBitmaps made from fetched blobs: Chromium decodes + premultiplies them off the
    // main thread and the upload drops from 40-75 ms to ~5 ms per sprite on a 4x-throttled phone. Elsewhere (and on
    // any failure) the <img> path is kept.
    var BITMAPS = !!(w.createImageBitmap && w.fetch && 'userAgentData' in navigator);
    function texLoad(src) {
      if (!src) return Promise.resolve(null);
      var img = function () { return loadImg(src, 'low').catch(function () { return null; }); };
      if (!BITMAPS) return img().then(decoded);
      return fetch(src, { mode: 'cors', credentials: 'omit', priority: 'low', headers: { Accept: 'image/avif,image/webp,image/*;q=0.8' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
        .then(function (b) { return w.createImageBitmap(b, { premultiplyAlpha: 'premultiply' }); })
        .catch(function () { return img().then(decoded); });
    }
    // Open-cranium skull. First paint: the small <img> sprites are the LCP; the anchors JSON (geometry only, no
    // pixels) places them exactly where the GL skull will be drawn. WebGL waits for a painted frame + idle while the
    // hero is near the viewport, then loads the full textures at low priority and initialises in yielded chunks.
    function startOpen(j) {
      A = normOpen(j, imgFa);
      AN = A ? w.PZPour.analyzeOpen(null, null, null, j) : null;
      if (!A || !AN) return false;
      if (mf && mf.firstElementChild && root.getAttribute('data-fill')) {
        var fu = 'url("' + root.getAttribute('data-fill') + '")';
        mf.firstElementChild.style.webkitMaskImage = fu; mf.firstElementChild.style.maskImage = fu;
      }
      relayout();
      Promise.all([imgReady(imgSk), imgReady(imgFa)]).then(function () { if (!dead) relayout(); });
      if (!w.PZPour || !canvas) { goStatic(); return true; }
      var started = false, stopNear = null;
      function go() {
        if (started || dead) return;
        started = true;
        if (stopNear) stopNear();
        var low = function (src) { return src ? loadImg(src, 'low').catch(function () { return null; }) : Promise.resolve(null); };
        Promise.all([texLoad(root.getAttribute('data-skull-back')), texLoad(root.getAttribute('data-skull-front')),
          texLoad(root.getAttribute('data-faucet')), texLoad(root.getAttribute('data-openings')), low(root.getAttribute('data-maps')).then(decoded)])
          .then(function (ims) {
            if (!ims[0] || !ims[1] || !ims[2] || !ims[3]) throw new Error('sprites');
            return yieldT(ims);
          })
          .then(function (ims) {
            if (dead) return null;
            // hit / film / bubble maps from the packed PNG when present (else read back from the full sprites)
            AN = (ims[4] ? w.PZPour.analyzeOpen(null, null, null, j, ims[4]) : w.PZPour.analyzeOpen(ims[0], ims[1], ims[3], j)) || AN;
            sprites = [ims[0], ims[1], ims[2], ims[3]];
            return yieldT();
          })
          .then(function () { if (!dead) startGL(); })
          .catch(fail);
      }
      // after the first painted frame, then the page load event (or 6 s), then idle (bounded), and only while the hero
      // is near the viewport
      Promise.all([imgReady(imgSk), imgReady(imgFa)]).then(function () {
        requestAnimationFrame(function () {
          setTimeout(function () {
            afterLoad(function () {
              if (dead) return;
              stopNear = PZ.inView(el, function (on) { if (on) idleCb(go, 2500); }, { media: false, rootMargin: '300px' });
            }, 6000);
          }, 0);
        });
      });
      return true;
    }
    jsonP.then(function (j) {
      if (dead) return null;
      if (!j) return placeholders();
      if (j.skull && j.skull.openings && root.getAttribute('data-openings') && w.PZPour && w.PZPour.analyzeOpen && startOpen(j)) return 'open';
      return Promise.all([
        loadImg(root.getAttribute('data-skull-back')).catch(function () { return null; }),
        loadImg(root.getAttribute('data-skull-front')).catch(function () { return null; }),
        loadImg(root.getAttribute('data-faucet')),
        loadImg(root.getAttribute('data-skull'))
      ]).then(function (ims) {
        var na = normAnchors(j, ims[3], ims[2]);
        if (!na) return placeholders();
        A = na;
        if (imgSk.getAttribute('src') !== root.getAttribute('data-skull')) imgSk.src = root.getAttribute('data-skull');
        if (imgFa.getAttribute('src') !== root.getAttribute('data-faucet')) imgFa.src = root.getAttribute('data-faucet');
        var back = ims[1] ? ims[0] : null, front = ims[1] || ims[3];
        AN = w.PZPour && w.PZPour.analyze ? w.PZPour.analyze(back, front, TILT, A) : null;
        if (!AN) AN = fallbackAnalysis(A, front);
        if (mf && back && mf.firstElementChild) {
          var mu = 'url("' + root.getAttribute('data-skull-back') + '")';
          mf.firstElementChild.style.webkitMaskImage = mu; mf.firstElementChild.style.maskImage = mu;
        }
        return [back, front, ims[2]];
      }, placeholders);
    }).then(function (ims) {
      if (dead || !ims || ims === 'open') return 'open';
      sprites = ims;
      return Promise.all([imgReady(imgSk), imgReady(imgFa)]);
    }).then(function (r) {
      if (dead || r === 'open') return;
      // legacy placeholders / tipped-back skull
      relayout();
      if (!sprites || !w.PZPour || !canvas) { goStatic(); return; }
      startGL();
    }).catch(fail);

    function onVis() { if (!pour) return; if (d.hidden) pour.stop(); else if (el.getBoundingClientRect().bottom > 0) pour.start(); }
    if ('ResizeObserver' in w) { ro = new ResizeObserver(relayout); ro.observe(stage); }
    w.addEventListener('resize', relayout);
    // the headline's text width (clearance) is only final once the display font is in
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { if (!dead && AN) relayout(); });

    return function () {
      dead = true;
      clearInterval(idleT);
      INPUTS.forEach(function (ev) { w.removeEventListener(ev, onInput, { capture: true }); });
      if (colTimer) cancelAnimationFrame(colTimer);
      if (stopIO) stopIO();
      if (ro) ro.disconnect();
      w.removeEventListener('resize', relayout);
      d.removeEventListener('visibilitychange', onVis);
      stage.removeEventListener('pointermove', onMove);
      stage.removeEventListener('pointerleave', onLeave);
      stage.removeEventListener('click', onClick);
      if (pour) pour.destroy();
    };
  }

  /* ------------------------------------------------------------------ headline */
  function initHeadline(el) {
    var h = el.querySelector('[data-hero-h1]');
    var kicker = el.querySelector('[data-hero-kicker]');
    if (!h) return function () {};
    var split = null, killed = false, mo = null, late = 0;
    function show() { el.classList.add('is-ready'); }
    if (PZ.reduced || !w.gsap || !w.SplitText) { show(); return function () {}; }
    // conversion guardrail: no reveal within 1.2 s of the headline being showable -> show it as is, no animation later
    function armLate() { late = setTimeout(function () { if (!el.classList.contains('is-ready')) { killed = true; show(); } }, 1200); }
    function run() {
      if (killed) return;
      try {
        split = w.SplitText.create(h, {
          type: 'lines', mask: 'lines', linesClass: 'pz-hero__line', autoSplit: true,
          onSplit: function (self) {
            show();
            if (killed || el.__pzRevealed) return;
            el.__pzRevealed = true; clearTimeout(late);
            return w.gsap.from(self.lines, { yPercent: 105, duration: 1.15, stagger: 0.09, ease: 'expo.out', delay: 0.05 });
          }
        });
      } catch (e) { show(); }
      if (kicker) PZ.scramble(kicker, { duration: 700, accent: 'var(--red)' });
    }
    var root = d.documentElement;
    if (root.classList.contains('pz-boot-on') && 'MutationObserver' in w) {
      mo = new MutationObserver(function () {
        if (!root.classList.contains('pz-boot-on')) { mo.disconnect(); mo = null; armLate(); run(); }
      });
      mo.observe(root, { attributes: true, attributeFilter: ['class'] });
    } else {
      armLate();
      (d.fonts && d.fonts.ready ? d.fonts.ready : Promise.resolve()).then(run);
    }
    return function () { killed = true; clearTimeout(late); if (mo) mo.disconnect(); if (split) split.revert(); };
  }

  /* ------------------------------------------------------------------ NOW_POURING compilation */
  function initNow(el) {
    var win = el.querySelector('[data-now]');
    var screen = el.querySelector('[data-now-screen]');
    var data = el.querySelector('[data-now-clips]');
    if (!win || !screen) return function () {};
    var titleEl = win.querySelector('.pz-win__title');
    var chEl = win.querySelector('[data-now-ch]');
    var prefix = (titleEl ? titleEl.textContent : 'NOW_POURING.MP4').replace(/\.MP4$/i, '');
    var filterId = (el.querySelector('.pz-hero__defs filter') || {}).id;
    var sel = el.getAttribute('data-scroll-target') || '[data-pz-section="grid"]';
    var clipMs = (parseFloat(el.getAttribute('data-clip-ms')) || 10) * 100;

    function onClick(e) {
      var t = null;
      try { t = d.querySelector(sel); } catch (err) { t = null; }
      if (!t) return;
      e.preventDefault();
      // Lenis (stopInertiaOnNavigate) resets on link clicks, so keep the click to ourselves and scroll next frame
      e.stopPropagation();
      requestAnimationFrame(function () { PZ.scrollTo(t); });
    }
    win.addEventListener('click', onClick);

    var clips = [];
    try { clips = JSON.parse(data ? data.textContent : '[]') || []; } catch (e) { clips = []; }
    var feat = clips.filter(function (c) { return c.f; }), stock = clips.filter(function (c) { return !c.f; });
    // phones: the small window cycles still covers only (no GIF features, no video); a cover that is itself a GIF
    // plays its still frame (ph), or is left out when it has none
    if (PHONE.matches && stock.length) {
      feat = [];
      stock = stock.filter(function (c) { return !/\.gif(\?|$)/i.test(c.src || '') || c.ph; });
    }
    var seq = [], n = Math.max(feat.length, stock.length);
    for (var i = 0; i < n; i++) {
      if (feat.length) seq.push(feat[i % feat.length]);
      if (stock.length) seq.push(stock[i % stock.length]);
    }
    if (!seq.length) return function () { win.removeEventListener('click', onClick); };
    var cache = new Map(), idx = -1, timer = 0, visible = false, dead = false, stopIO = null, cutT = 0;

    // Liquid only exposes the 1080p mp4; the AJAX product JSON lists every rendition, so swap in the smallest.
    // Videos go through the shop domain (/cdn/shop/videos/, answers 206): cdn.shopify.com answers the first
    // "Range: bytes=0-" with a plain 200, which leaves the video unseekable (random start, intro skip).
    function shopVideoUrl(u) { return String(u || '').replace(/^(https?:)?\/\/cdn\.shopify\.com\/videos\//, '/cdn/shop/videos/'); }
    var prodCache = {};
    function smallest(c) {
      return smallest0(c).then(shopVideoUrl);
    }
    function smallest0(c) {
      if (!c.url || !c.mid) return Promise.resolve(c.src);
      if (!prodCache[c.url]) prodCache[c.url] = fetch(c.url + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      return prodCache[c.url].then(function (pj) {
        var best = null;
        ((pj && pj.media) || []).forEach(function (m) {
          if (m.id !== c.mid) return;
          (m.sources || []).forEach(function (s) { if (s.format === 'mp4' && s.height && (!best || s.height < best.height)) best = s; });
        });
        return best ? best.url : c.src;
      });
    }
    function node(c) {
      if (cache.has(c)) return cache.get(c);
      var m;
      if (c.t === 'v') {
        m = d.createElement('video');
        m.muted = true; m.loop = true; m.playsInline = true; m.setAttribute('playsinline', ''); m.setAttribute('muted', '');
        m.preload = 'auto';
        if (c.poster) m.poster = c.poster;
        smallest(c).then(function (src) { if (!dead) m.src = src; });
      } else {
        m = d.createElement('img');
        m.alt = ''; m.decoding = 'async';
        m.src = PHONE.matches && c.ph ? c.ph : c.src;
        if (c.px) m.className = 'is-px';
      }
      m.__clip = c;
      screen.appendChild(m);
      cache.set(c, m);
      return m;
    }
    // only the clip on screen holds media: a cut-away video is unloaded (src removed + load()), a GIF is dropped
    // (stops animating and decoding); both are rebuilt from the browser cache when they come round again
    function release(m) {
      if (!m || !m.__clip) return;
      cache.delete(m.__clip);
      if (m.tagName === 'VIDEO') { try { m.pause(); m.removeAttribute('src'); m.load(); } catch (e) {} }
      else m.removeAttribute('src');
      if (m.parentNode) m.parentNode.removeChild(m);
    }
    // preload the next clip only when it is an image (videos start loading when they are cut to)
    function isGif(c) { return !!(c.gif || /\.gif(\?|$)/i.test(c.src || '')); }
    function preloadNext(k) {
      var c = seq[(k + 1) % seq.length];
      if (c && c.t !== 'v' && (!isGif(c) || (PHONE.matches && c.ph))) node(c);
    }
    // a clip with an intro (skip-listed, e.g. 450 North's VHS splash) is only cut to once it plays past it
    function inIntro(m, c) {
      return !!(c.skip && (m.currentTime < c.skip - 0.1 || (PZ.videoInIntro && PZ.videoInIntro(m))));
    }
    var pend = null;
    function cancelPend() { if (pend) { pend.off(); pend = null; } }
    function show(k) {
      var c = seq[k], m = node(c);
      cancelPend();
      function swap() {
        var prev = screen.querySelector('.is-on');
        screen.classList.add('is-cut');
        if (filterId) m.style.filter = 'url(#' + filterId + ')';
        if (prev && prev !== m) { prev.classList.remove('is-on'); prev.style.filter = ''; release(prev); }
        // drop any other stale nodes except the preloaded next image
        Array.prototype.slice.call(screen.children).forEach(function (x) {
          if (x !== m && x.__clip && x.__clip !== seq[(k + 1) % seq.length]) release(x);
        });
        m.classList.add('is-on');
        if (titleEl) titleEl.innerHTML = '<span class="pz-hero__nowpre">' + prefix + ': </span>' + c.name.replace(/[<>&]/g, '');
        if (chEl) chEl.textContent = 'CH ' + pad2(k + 1) + '/' + pad2(seq.length) + (c.in ? '' : ' · SOLD OUT');
        clearTimeout(cutT);
        cutT = setTimeout(function () { screen.classList.remove('is-cut'); m.style.filter = ''; }, 90);
      }
      if (m.tagName === 'VIDEO') {
        var sk = c.skip || 0;
        try { if (isFinite(m.duration) && m.duration > sk + 1.4) m.currentTime = sk + Math.random() * (m.duration - sk - 1.2); } catch (e) {}
        var p = m.play(); if (p && p.catch) p.catch(function () {});
        if (inIntro(m, c)) {
          // keep the previous clip on screen until this one is past its intro; give up after ~0.8 clip
          var t0 = performance.now();
          var chk = function () {
            if (!inIntro(m, c)) { cancelPend(); swap(); }
            else if (performance.now() - t0 > clipMs * 0.8) { cancelPend(); m.pause(); }
          };
          ['timeupdate', 'seeked', 'playing'].forEach(function (ev) { m.addEventListener(ev, chk); });
          pend = { off: function () { ['timeupdate', 'seeked', 'playing'].forEach(function (ev) { m.removeEventListener(ev, chk); }); } };
          preloadNext(k);
          return;
        }
      }
      swap();
      preloadNext(k);
    }
    function next() {
      timer = 0;
      if (dead || !visible || d.hidden) return;
      idx = (idx + 1) % seq.length;
      show(idx);
      timer = setTimeout(next, clipMs);
    }
    // conversion guardrail: the compilation starts cutting (and loading clips) only after the window load event +
    // idle; until then the window shows its poster
    var armed = false;
    afterLoad(function () { idleCb(function () { armed = true; if (!dead && visible && !timer) timer = setTimeout(next, 400); }); });
    function setVisible(on) {
      visible = on;
      if (visible && !timer && armed) timer = setTimeout(next, idx < 0 ? 400 : clipMs);
      if (!on) {
        clearTimeout(timer); timer = 0;
        var cur = screen.querySelector('.is-on');
        if (cur && cur.tagName === 'VIDEO') cur.pause();
        // an animated GIF keeps decoding off screen: park it on its still (or an empty pixel) until it comes back
        if (cur && cur.tagName === 'IMG' && cur.__clip && isGif(cur.__clip) && !cur.__gsrc) {
          cur.__gsrc = cur.getAttribute('src');
          cur.src = cur.__clip.ph || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        }
      } else {
        var cur2 = screen.querySelector('.is-on');
        if (cur2 && cur2.__gsrc) { cur2.src = cur2.__gsrc; cur2.__gsrc = null; }
        if (cur2 && cur2.tagName === 'VIDEO') { var p = cur2.play(); if (p && p.catch) p.catch(function () {}); }
      }
    }
    function onVis() { setVisible(visible || (!d.hidden && el.getBoundingClientRect().bottom > 0)); }
    stopIO = PZ.inView(el, setVisible, { media: false });
    d.addEventListener('visibilitychange', onVis);
    return function () {
      dead = true;
      clearTimeout(timer); clearTimeout(cutT); cancelPend();
      if (stopIO) stopIO();
      d.removeEventListener('visibilitychange', onVis);
      win.removeEventListener('click', onClick);
    };
  }

  /* ------------------------------------------------------------------ first-screen height */
  // header + hero + marquee fill the first viewport: the stage height (CSS, 100svh) subtracts the measured
  // document offset of the hero (status bar + header) and the marquee height.
  function initHeight(el) {
    var mq = d.querySelector('[data-pz-section="marquee"]');
    var watch = [mq, d.querySelector('[data-pz-status]'), d.querySelector('.pz-header')];
    var raf = 0;
    function set() {
      raf = 0;
      var top = Math.max(0, Math.round(el.getBoundingClientRect().top + (w.scrollY || w.pageYOffset || 0)));
      var cs = getComputedStyle(d.documentElement), top0 = (parseFloat(cs.getPropertyValue('--status-h')) || 0) + (parseFloat(cs.getPropertyValue('--header-h')) || 0);
      var vw = w.innerWidth, mqh = mq ? mq.getBoundingClientRect().height : 0;
      var mq0 = 2 * clamp(vw * 0.0125, 13, 20) + 0.96 * clamp(vw * 0.029, 26, 42) + 1; // the CSS fallback (--mq-h0)
      if (Math.abs(top - top0) >= 1 || el.style.getPropertyValue('--pz-top')) el.style.setProperty('--pz-top', top + 'px');
      if (Math.abs(mqh - mq0) >= 1 || el.style.getPropertyValue('--mq-h')) el.style.setProperty('--mq-h', mqh + 'px');
    }
    function queue() { if (!raf) raf = requestAnimationFrame(set); }
    set();
    var ro = 'ResizeObserver' in w ? new ResizeObserver(queue) : null;
    if (ro) watch.forEach(function (n) { if (n) ro.observe(n); });
    w.addEventListener('resize', queue);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(queue);
    return function () { if (ro) ro.disconnect(); w.removeEventListener('resize', queue); if (raf) cancelAnimationFrame(raf); };
  }

  PZ.onSection('hero', function (el) {
    var stage = el.querySelector('[data-stage]') || el;
    var fns = [initHeight(el), initHeadline(el)];
    var floaters = initFloaters(el, stage);
    fns.push(floaters.destroy, initPour(el, stage, floaters), initNow(el));
    return function () { fns.forEach(function (f) { f(); }); };
  });
})();
